module.exports = __webpack_public_path__ + "img/patent2.575acd25.jpg";